export default __webpack_public_path__ + "static/media/IMG_6896.2cd2bd73.jpg";